<nav class="navbar" role="navigation" aria-label="Main navigation">
  <div class="nav-content">
    <ul class="nav-tabs" role="tablist">
      @for (tab of visibleTabs(); track tab.label) {
        <li [class.active]="currentActiveTab() === tab.label" role="presentation">
          @if (isTabActive(tab.label)) {
            <span 
              class="nav-tab-disabled"
              role="tab"
              [attr.aria-selected]="true"
              tabindex="0">
              {{ tab.label }}
            </span>
          } @else {
            <a 
              [routerLink]="tab.route" 
              role="tab"
              [attr.aria-selected]="false"
              tabindex="-1">
              {{ tab.label }}
            </a>
          }
        </li>
      }
    </ul>
  </div>
</nav>
